<template>
    <div class="resolve">
        <div class="resolve_pain">
            <div class="pain_title">行业痛点</div>
            <div style="width: 3rem; border: 1px solid #56defc; margin-bottom: 3rem;"></div>
            <div :style="{'width': painNumber === 3 ? '100%' : '80%'}">
                <trace-pain :painNumber="painNumber"></trace-pain>
            </div>
        </div>
        <div class="resolve_projects">
            <div class="pain_title">解决方案</div>
            <div style="width: 3rem; border: 1px solid #56defc;"></div>
            <div class="pain_title2">我们只有更专业，客户才能用的放心</div>
            <!-- <div style="width: 80%; border: 1px solid #fff; margin: 1rem;"></div> -->
            <resolve-projects :projects="projects"></resolve-projects>
            <div>
                <el-button>获取详细方案</el-button>
            </div>
        </div>
        <div class="resolve_success">
            <div class="pain_title">成功案例</div>
            <div style="width: 3rem; border: 1px solid #56defc;"></div>
            <div class="pain_title2">助力企业通过数字孪生 更便捷的认知和管理现实世界</div>
            <successful-projects :succ="succ"></successful-projects>
        </div>
    </div>
</template>

<script>
import TracePain from '../tracePain'
import ResolveProjects from '../resolveProjects'
import { successfulProjects } from '../../util/constant'
export default {
    data() {
        return{
            digitalSolutions:this.solutions,
            successfulProjects:successfulProjects,
        }
    },
    props: {
        projects : Array,
        succ: Object,
        painNumber: Number
    },
    components: {
        TracePain,
        ResolveProjects,
    },
    methods: {

    },
    mounted() {
        // console.log(this.title)
    }
}
</script>

<style scoped lang="less">
.resolve {
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // width: 15rem;
    // height: 5rem;
    .resolve_pain {
        width: 90%;
        color: #fff;
        font-size: 1.5rem;
        font-family: 'Microsoft YaHei';
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 50px;
    }
    .pain_title {
        margin: 0rem 0 0.5rem 0;
    }
    .pain_title2 {
        margin: 0.5rem 0 0.5rem 0;
        font-size: 1rem;
        color: #c4c4c4;
    }
    .resolve_projects {
        width: 90%;
        color: #fff;
        font-size: 1.5rem;
        font-family: 'Microsoft YaHei';
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .resolve_success {
        width: 90%;
        color: #fff;
        font-size: 1.5rem;
        font-family: 'Microsoft YaHei';
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
.title_main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10rem;
}

.el-button {
    border-radius: 20px;
    color: #ffffff;
    background: #54defc;
    box-shadow: 0px 5px 5px #000;
    font-size: 15px;
    margin: 0 0 4rem 0;
}
// .title_container {
//     display: flex;
//     flex-direction: column;
//     top: 0;
//     z-index: 9999;
//     background: #000000;
//     color: #fff;
//     width: 60%;
//     justify-content: center;
//     height: 50%;
//     text-align: center;
//     align-items: center;
    
// }
</style>
